<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('creditTransfer.pageTitle') }}
      </h1>
      <ts-breadcrumb :items="[
        { text: $t('toHomePage'), href: '/' },
        {
          text: $t('creditTransfer.pageTitle'),
          active: true
        }
      ]" />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-sm-4">
            <ts-button color="info" outline :loading="waiting"
              @click="$router.push({ name: 'credit-transfer-create' })">{{
                $t('add_new')
              }}</ts-button>
          </div>
          <div class="col-sm-8 d-flex justify-content-end">
            <ts-input v-model="search" :placeholder="$t('search')" style="width: 300px" />
          </div>
        </div>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-table :columns="columns" :records="resources" :loading="loading" :expandable="true">
          <template v-slot="{ record }">
            <td class="ts-whitespace-no-wrap">
              {{ record.full_name_kh }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.full_name_en }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.gender }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.school_university }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.degree }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.department }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.number_of_year_studied }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.number_of_semester_studied }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.sub_program ? record.sub_program.acps_name_foreign : '' }}

            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.level ? record.level.level_name_foreign : '' }}

            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.academic_year ? record.academic_year.ac_year : '' }}

            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.ac_term ? record.ac_term.term_name : '' }}

            </td>
            <!-- <td class="ts-whitespace-no-wrap">
              <span v-for="(detail, index) in record.subject_details">
								{{ detail.subject_name }} <br>
							</span>
            </td>
            <td class="ts-whitespace-no-wrap">
              <span v-for="(detail, index) in record.subject_details">
								{{ detail.subject.subject_name_foreign }} <br>
							</span>
            </td> -->
            <td class="ts-whitespace-no-wrap">
              {{
                record.created_by
                  ? record.created_by.employee
                    ? record.created_by.employee.name_en
                    : record.created_by.loginname
                  : ''
              }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{
                record.created_date

              }}
            </td>
            <td class="text-left ts-whitespace-no-wrap">

              <a href="#" v-tooltip="$t('creditTransfer.addStudentProfile')" class="ml-2 text-primary"@click.prevent="showFormStudent(record)">
                <i class="fas fa-users"></i>

              </a>
              <a href="#" v-tooltip="$t('view')" class="ml-2 text-info" @click.prevent="showFormListView(record)"
                v-if="record.attached_agreement">
                <i class="fas fa-eye"></i>
              </a>
              <a href="#" class="ml-2 text-primary" v-tooltip="$t('creditTransfer.uploadFile')"
                @click.prevent="showFormAttachedFile(record)">
                <i class="fas fa-file-upload"></i>
              </a>
              <a href="#" v-tooltip="$t('pdf')" class="text-danger ml-2" @click.prevent="print(record)">
                <i class="fas fa-file-pdf"></i>
              </a>
              <a href="#" title="delete" class="text-danger ml-2" @click.prevent="destroy(record.id)">
                <i class="fas fa-trash"></i>
              </a>
            </td>

          </template>
          <div slot="expand" slot-scope="prop">
            <table class="ts-w-full ts-mx-auto detail">
              <thead>
                <tr>
                  <th>{{ $t('creditTransfer.numberOfYear') }}</th>
                  <th>{{ $t('creditTransfer.numberOfSemeter') }}</th>
                  <th>{{ $t('creditTransfer.subject') }}</th>
                  <th>{{ $t('creditTransfer.credit') }}</th>
                  <th>{{ $t('creditTransfer.grade') }}</th>
                  <th>{{ $t('creditTransfer.equalAcYear') }}</th>
                  <th>{{ $t('creditTransfer.equalAcTerm') }}</th>
                  <th>{{ $t('creditTransfer.equalSubject') }}</th>
                  <th>{{ $t('creditTransfer.equalCredit') }}</th>
                  <th>{{ $t('creditTransfer.equalGrade') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(detail, index) in prop.record.subject_details">
                  <td class="ts-whitespace-no-wrap">{{ detail.academic_year }} </td>
                  <td class="ts-whitespace-no-wrap">{{ detail.academic_semester }} </td>
                  <td class="ts-whitespace-no-wrap">{{ detail.subject_name }} </td>
                  <td class="ts-whitespace-no-wrap">{{ detail.subject_credit }} </td>
                  <td class="ts-whitespace-no-wrap">{{ detail.subject_grade }} </td>
                  <td class="ts-whitespace-no-wrap">{{ detail.equi_academic_year }} </td>
                  <td class="ts-whitespace-no-wrap">{{ detail.equi_academic_semester }} </td>
                  <td class="ts-whitespace-no-wrap">{{ detail.subject.subject_name_foreign }} </td>
                  <td class="ts-whitespace-no-wrap">{{ detail.equi_subject_credit }} </td>
                  <td class="ts-whitespace-no-wrap">{{ detail.equi_subject_grade }} </td>
                </tr>
              </tbody>
            </table>
          </div>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end ts-p-4">
        <ts-pagination v-model="pagination" @navigate="fetchData"></ts-pagination>
      </div>
    </ts-card>
    <a-modal :title="$t('pdf')" width="70%" v-model="show_pdf" :footer="null">
      <ts-preview-pdf v-model="waiting" :src="src" />
    </a-modal>
    <a-modal v-model="show_list_view" v-if="show_list_view" centered @ok="() => (show_list_view = false)" :zIndex="1020"
      :footer="null" width="50%">

      <list-view :resources="view_resources" />
    </a-modal>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { debounce } from 'lodash'
import FormAttachedFile from './components/attached-file.vue'
import listView from './components/list-view.vue'

export default {
  name: 'credit-transfer',
  components: {
    FormAttachedFile,
    listView
  },
  data() {
    return {
      waiting: false,
      loading: false,
      show_pdf: false,
      show_list_view: false,
      photoLoading: false,
      show_form_student: false,
      src: '',
      view_resources: [],
      model: {
        attached_agreement: ''
      }

    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('crediTransfer', ['resources', 'pagination']),

    columns() {
      return [
        {
          name: this.$t('creditTransfer.studentNameKh'),
        },
        {
          name: this.$t('creditTransfer.studentName'),
        },
        {
          name: this.$t('creditTransfer.gender'),

        },
        {
          name: this.$t('creditTransfer.fromSchool'),

        },
        {
          name: this.$t('creditTransfer.level'),

        },
        {
          name: this.$t('creditTransfer.major'),

        },
        {
          name: this.$t('creditTransfer.numberOfYear'),

        },
        {
          name: this.$t('creditTransfer.numberOfSemeter'),

        },
        {
          name: this.$t('creditTransfer.equalmajor'),

        },
        {
          name: this.$t('creditTransfer.equallevel'),

        },
        {
          name: this.$t('creditTransfer.equalAcYear'),

        },
        {
          name: this.$t('creditTransfer.equalAcTerm'),
        },
        {
          name: this.$t('creditTransfer.createdBy'),
        },
        {
          name: this.$t('creditTransfer.createdDate'),
        },
        {
          name: this.$t('administration.company.actions'),
          style: 'width:10%; text-align:left'
        }

      ]
    },
    search: {
      get() {
        return this.$store.state.crediTransfer.search
      },
      set(newValue) {
        this.$store.commit('crediTransfer/SET_SEARCH', newValue)
        this.$store.commit('crediTransfer/RESET_CURRENT_PAGE')
      }
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch(
          'crediTransfer/fetch',
          Object.assign(
            {
              branch_id: this.branch_id
            },
            { ...attributes }
          )
        )
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    async destroy(id) {
      if (await this.$confirmModal.danger('Are you sure to delete ?')) {
        this.$store
          .dispatch('crediTransfer/delete', id)
          .then(response => {
            this.$toasted.success(response.message)
            this.fetchData()
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
      }
    },
    print(record) {
      this.show_pdf = true
      this.waiting = true
      this.src = ''
      this.$store
        .dispatch('crediTransfer/printPdf', record.id)
        .then(response => {
          this.src = response.url
          this.fetchData()
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    showFormAttachedFile(record) {
      console.log(record);
      
      this.$store.commit('crediTransfer/SET_EDIT_DATA', record)

      this.$modal.show(
        FormAttachedFile,
        {
          params: { id: record.id }
        },
        {
          height: 'auto',
          width: '980px',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        },
        {
          'before-close': this.fetchData
        }
      )
    },
    showFormListView(record) {
      this.show_list_view = true
      this.view_resources = record
    },
    showFormStudent(record){ 
      this.$store.commit('crediTransfer/SET_EDIT_DATA', record)    
      this.$router.push({
        name: 'form-student-create',
        params: { id: record.id }
      })
    },

  },
  watch: {
    search: debounce(function (search) {
      this.fetchData({ search })
    }, 500)
  },
}
</script>
